
export default function Heritage() {
  return (
    <section id="heritage" className="py-24 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-amber-600 text-sm font-semibold tracking-widest uppercase mb-4 block" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Ancient Roots, Pure Excellence
          </span>
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Six Generations of Mediterranean Mastery
          </h3>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Brought to you by <strong>6 generations of olive oil harvesting</strong> from <strong>ancient wild trees</strong> located in a <strong>mountainous region in Tunisia</strong>
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative h-96 md:h-[500px] rounded-2xl overflow-hidden shadow-2xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/a3ddfaaa4ea42b93fb03985441c6db49.jpg" 
              alt="Ancient wild olive tree in Tunisia"
              className="w-full h-full object-cover object-center"
            />
          </div>
          
          <div className="space-y-6">
            <div className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                <i className="ri-plant-line text-amber-600 text-2xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Ancient Wild Olive Trees
                </h4>
                <p className="text-gray-700 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Our <strong>olive oil</strong> comes from wild, centuries-old trees that have thrived in Tunisia's unique mountainous terrain, producing olives with exceptional flavor and nutritional value.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                <i className="ri-time-line text-amber-600 text-2xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Early Season Harvest
                </h4>
                <p className="text-gray-700 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  <strong>Cold-pressed in early season</strong>, our olives are harvested at peak ripeness to ensure maximum <strong>polyphenol</strong> content and that distinctive peppery finish characteristic of premium <strong>extra virgin olive oil</strong>.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                <i className="ri-hand-heart-line text-amber-600 text-2xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Handpicked with Care
                </h4>
                <p className="text-gray-700 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Every olive is <strong>handpicked</strong> by skilled harvesters who understand the delicate nature of this precious fruit, ensuring only the finest olives make it to pressing.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center">
                <i className="ri-ancient-gate-line text-amber-600 text-2xl"></i>
              </div>
              <div>
                <h4 className="text-xl font-semibold text-gray-900 mb-2" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Carthaginian Legacy
                </h4>
                <p className="text-gray-700 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Our <strong>olive oil</strong> brings to you thousands of years of history and legacy from the ancient <strong>Carthaginian</strong> civilization, where <strong>olive cultivation</strong> was perfected along the <strong>Mediterranean coast</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-amber-600 to-amber-500 rounded-2xl p-12 text-white text-center shadow-xl">
          <h4 className="text-3xl font-bold mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            The Carthaginian Connection
          </h4>
          <p className="text-lg leading-relaxed max-w-4xl mx-auto text-white/95" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Ancient <strong>Carthage</strong>, located in modern-day Tunisia, was renowned throughout the <strong>Mediterranean</strong> for its agricultural prowess. The Carthaginians perfected <strong>olive cultivation</strong> techniques over 3,000 years ago, establishing Tunisia as one of the world's premier <strong>olive oil</strong> producing regions. Today, we honor this legacy by maintaining the same dedication to quality and tradition that made Carthaginian <strong>olive oil</strong> legendary across the ancient world.
          </p>
        </div>
      </div>
    </section>
  );
}
